/**
 * Animated Content Component
 *
 * Zeigt animiertes Logo und rotierende Nachrichten
 */

export interface AnimatedContentProps {
  logoPath: string;
  currentMessage: string;
}

export function AnimatedContent({ logoPath, currentMessage }: AnimatedContentProps) {
  return (
    <>
      {/* Animiertes Logo */}
      <div className="relative">
        <img src={logoPath} alt="GOKI" className="h-[110px] w-[110px] animate-pulse" />
        <div className="absolute inset-0 animate-ping">
          <img src={logoPath} alt="" className="h-[110px] w-[110px] opacity-30" />
        </div>
      </div>

      {/* Rotierender Text mit Pulsieren */}
      <div className="flex items-center gap-0.5 text-lg font-medium text-orange-700 dark:text-orange-300">
        <span
          className="transition-opacity duration-300 animate-pulse"
          style={{ textShadow: '0 0 8px rgba(251, 146, 60, 0.3)' }}
        >
          {currentMessage}
        </span>
        <span className="inline-flex gap-0.5">
          <span className="animate-bounce [animation-delay:0ms]">.</span>
          <span className="animate-bounce [animation-delay:150ms]">.</span>
          <span className="animate-bounce [animation-delay:300ms]">.</span>
        </span>
      </div>
    </>
  );
}
